<template>
  <section id="section-collections">
    <CollectionItem
      v-for="(collectionItem, index) in sortedData"
      :key="index"
      :collectionItem="collectionItem"
    />
  </section>
</template>

<script>
import CollectionItem from "@/components/sections/MainPage/CollectionItem";
import { mapState } from "vuex";
export default {
  name: "Collections",
  components: {
    CollectionItem
  },
  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      gridOrder: ["double"],
      sortedData: []
    };
  },
  mounted() {
    if (
      this.global.mainPage.grid_layout &&
      this.global.mainPage.grid_layout.length > 0
    ) {
      this.gridOrder = this.global.mainPage.grid_layout;
    }
    let filteredCollections = [];
    if (
      this.global.mainPage.collection_ids &&
      this.global.mainPage.collection_ids.length > 0
    ) {
      filteredCollections = this.global.mainPage.collection_ids.map(
        collectionId => {
          return this.global.collections.find(
            collection => collectionId === collection.id
          );
        }
      );
    }
    filteredCollections = filteredCollections.filter(item => item != null);

    this.sortedData = this.sortData(filteredCollections);
  },
  methods: {
    sortData(array) {
      let sortedData = [];

      let currentArrayPosition = 0;
      let currentGridOrderPos = 0;
      while (currentArrayPosition < array.length) {
        if (currentGridOrderPos > this.gridOrder.length - 1) {
          currentGridOrderPos = 0;
        }
        let loopLength = 0;
        let currentType = this.gridOrder[currentGridOrderPos];
        currentGridOrderPos++;

        switch (currentType) {
          case "single":
            loopLength = 1;
            break;
          case "double":
            loopLength = 2;
            break;
          case "triple":
            loopLength = 3;
            break;
          case "triple-reverse":
            loopLength = 3;
            break;
          default:
            currentType = "double";
            loopLength = 2;
            break;
        }
        if (loopLength > array.length - currentArrayPosition) {
          loopLength = array.length - currentArrayPosition;
          switch (loopLength) {
            case 1:
              currentType = "single";
              break;
            case 2:
              currentType = "double";
              break;
            case 3:
              currentType = "triple";
              break;
            default:
              currentType = "single";
              break;
          }
        }
        let currentSortedItem = {
          type: currentType,
          items: []
        };
        for (let i = 0; i < loopLength; i++) {
          if (array[currentArrayPosition] == null) {
            currentArrayPosition++;
            continue;
          }
          currentSortedItem.items.push(array[currentArrayPosition]);
          currentArrayPosition++;
        }
        sortedData.push(currentSortedItem);
      }
      return sortedData;
    }
  }
};
</script>

<style lang="scss" scoped>
#section-collections {
  background: #000;
  z-index: 5;
  position: relative;
}
</style>